import {maybeLoadGmaps, GMAPS_NOT_NEEDED} from "../../../../packages/javascript/maybe-load-gmaps";

export function oncarrotMap() {
    const lazyLoadFlxMapQ = window.CARROT_LAZY_LOAD_FLXMAP_Q;
    if (!lazyLoadFlxMapQ || lazyLoadFlxMapQ.length < 1) {
        return;
    }

    maybeLoadGmaps({jQuery: jQuery})
        .then(function () {
            import('./flexible-map.js').then(function (m) {
                const FlexibleMap = m.FlexibleMap;
                while(lazyLoadFlxMapQ.length > 0) {
                    const callback = lazyLoadFlxMapQ.shift();
                    callback(FlexibleMap);
                }
            });
        });
}




// WEBPACK FOOTER //
// /site/web/app/plugins/oncarrot-map/index.js